module.exports = __webpack_public_path__ + "img/logo-magento.9409d99b.svg";